import React from "react"
import { FormattedMessage } from "react-intl"
import classnames from "classnames"
import { useIsLangEN } from "../hooks"

const PageTitle = ({ title, mobileSubTitleKey }) => {
  const isLangEN = useIsLangEN()
  return (
    <div
      className={classnames({
        "page-title": true,
        "page-title--en": isLangEN,
      })}
    >
      <div className="page-title__subtitle">
        {mobileSubTitleKey && (
          <FormattedMessage id={mobileSubTitleKey}></FormattedMessage>
        )}
      </div>
      <h1 dangerouslySetInnerHTML={{ __html: title }}></h1>
    </div>
  )
}

export default PageTitle
